import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { select, Store } from '@ngrx/store'
import {
  Attachment,
  AttachmentService,
  AttachmentsGuard,
  DataCheckerService,
  Destroyable,
  selectAllAttachments,
} from '@tokeet-frontend/tv3-platform'
import { map } from 'rxjs/operators'

interface SelectableFile {
  selected: boolean
  attachment
}

@Component({
  selector: 'app-attachment-select',
  templateUrl: './attachment-select.component.html',
  styleUrls: ['./attachment-select.component.scss'],
})
export class AttachmentSelectComponent extends Destroyable implements OnInit {
  @Input() allowedFileExtensions: string[]
  @Output() done = new EventEmitter()
  @Output() close = new EventEmitter()
  available: SelectableFile[] = []
  selected: SelectableFile[] = []
  queryAvailable: string
  querySelected: string

  constructor(private store: Store<any>, private attachment: AttachmentService, dataChecker: DataCheckerService) {
    super()
    dataChecker.check([AttachmentsGuard])
  }

  ngOnInit() {
    this.store
      .pipe(
        select(selectAllAttachments),
        map((items) => items?.filter((t) => this.isAllowedFile(t)))
      )
      .subscribe((attachments) => {
        this.available = attachments.map((attachment) => ({
          selected: false,
          attachment,
        }))
      })
  }

  isAllowedFile(item: Attachment) {
    if (!item.name && !this.allowedFileExtensions?.length) {
      return false
    }
    if (!this.allowedFileExtensions?.length) {
      return true
    }
    const ext = item.name.split('.').pop()
    return this.allowedFileExtensions.includes(`.${ext}`)
  }

  onMoveAvailable() {
    const checked = this.available.filter((i) => i.selected)
    this.available = this.available.filter((i) => !i.selected)
    checked.forEach((i) => (i.selected = false))
    this.selected = [...checked, ...this.selected]
  }

  onMoveAllAvailable() {
    this.selected = [...this.available, ...this.selected]
    this.selected.forEach((i) => (i.selected = false))
    this.available = []
  }

  onMoveSelected() {
    const checked = this.selected.filter((i) => i.selected)
    this.selected = this.selected.filter((i) => !i.selected)
    checked.forEach((i) => (i.selected = false))
    this.available = [...checked, ...this.available]
  }

  onMoveAllSelected() {
    this.available = [...this.selected, ...this.available]
    this.available.forEach((i) => (i.selected = false))
    this.selected = []
  }

  onDone() {
    const attachments = this.selected.map((i) => i.attachment)
    this.done.emit(attachments)
  }
}
